import React from "react";
import { Route, Navigate } from "react-router-dom";

// USER PAGES
import Home from "../pages/user/Home";
import ShopHome from "../pages/user/Shop";
import ProductDetails from "../pages/user/ProductDetails";
import SearchPage from "../pages/user/SearchPage";
import CartPage from "../pages/user/CartPage";
import WishlistPage from "../pages/user/WishlistPage";
import CheckoutPage from "../pages/user/CheckoutPage";
import TrackOrder from "../pages/user/TrackOrder";
import PaymentPage from "../pages/user/PaymentPage";
import OrderSuccess from "../pages/user/OrderSuccess";

import Login from "../pages/auth/Login";

const PublicRoutes = () => {
  return (
    <>
      {/* Root URL → Shop */}
      <Route path="/" element={<Navigate to="/shop" replace />} />

      {/* Authentication */}
      <Route path="/login" element={<Login />} />

      {/* USER PAGES */}
      <Route path="/home" element={<Home />} />

      <Route path="/shop" element={<ShopHome />} />
      <Route path="/product/:id" element={<ProductDetails />} />
      <Route path="/search" element={<SearchPage />} />

      <Route path="/cart" element={<CartPage />} />
      <Route path="/wishlist" element={<WishlistPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/track-order" element={<TrackOrder />} />

      <Route path="/payment/:orderId" element={<PaymentPage />} />
      <Route path="/user/ordersuccess/:orderId" element={<OrderSuccess />} />
    </>
  );
};

export default PublicRoutes;
